module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_diamond_hazel.891e4431.png";